<div class="page-layout simple fullwidth">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <h2>{{ "CONTRACTORS.CONTRACTORS" | translate | uppercase }}</h2>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">
        <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div class="h1 pr-16">Contratistas</div>
                <button
                    mat-icon-button
                    color="accent"
                    (click)="mostrarFiltros = !mostrarFiltros"
                >
                    {{ mostrarFiltros ? "Ocultar filtros" : "Mostrar filtros" }}
                    <mat-icon>{{
                        mostrarFiltros
                            ? "keyboard_arrow_up"
                            : "keyboard_arrow_down"
                    }}</mat-icon>
                </button>
            </div>

            <app-filtro-contratistas
                *ngIf="comunas && grupos"
                class="mb-16"
                [hidden]="!mostrarFiltros"
                [comunas]="comunas"
                [grupos]="grupos"
                [evaluaciones]="evaluaciones"
                [estados]="estados"
                (filtrarContratistas)="filtrar($event)"
            ></app-filtro-contratistas>
            <app-tabla-contratistas
                *ngIf="contratistas"
                [contratistas]="contratistas"
                (buscarMas)="buscarContratistas($event)"
            ></app-tabla-contratistas>
        </div>
    </div>
    <!-- / CONTENT -->
</div>
<button
    *ngIf="_menuUsuarioSrvc.esSupervisor() && bancos && tiposCuenta"
    mat-fab
    class="accent"
    id="agregar-contratista-button"
    (click)="nuevoContratista()"
    aria-label="Nuevo Contratista"
    [@animate]="{ value: '*', params: { delay: '300ms', scale: '.2' } }"
>
    <mat-icon>add</mat-icon>
</button>
